/* eslint max-len: ["error", { "ignoreStrings": true }] */

const metaInfo = {
  // SEO metadata
  brands: {
    en: 'Binance.US',
  },
  metaTitles: {
    en: 'Buy and Sell Bitcoin, Ethereum, and other Cryptocurrency | Binance US',
  },
  metaKeywords: {
    // en is fallback
    en:
      'Binance US',
  },
  metaDescriptions: {
    // en is fallback
    en:
      'Binance US',
  },
};

export default metaInfo;
